import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const humanizeDate = (rawDate: string) =>
  format(new Date(rawDate), 'd MMMM', { locale: ru });
